.root {
  display: flex;
  justify-content: center;
  width: max-content;
  height: var(--form-item-base-height);
  margin: 0 auto;
  margin-top: 2rem;
  overflow: hidden;
  border: 1px solid var(--gray-300);
  border-radius: 4px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: var(--form-item-base-height);
  padding: 0.25rem;
  font-weight: var(--font-weight-light);
  appearance: none;
  cursor: pointer;
  background: none;
  border-color: var(--gray-300);
  border-style: solid;
  border-width: 0;

  &:last-child {
    border-left-width: 1px;
  }

  &:first-child {
    border-right-width: 1px;
  }
}

.display {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  cursor: default;
}

.disabled {
  pointer-events: none;
  cursor: not-allowed;
  background-color: var(--surface);
}
